import { Action, createAction, props } from '@ngrx/store';

export const setApplicationsInChain = createAction(
    '[Application Chain] Set With Applications',
    props<{ applications: any }>()
);